import { Badge } from '@mantine/core';
import { LEAVE_STATUS_COLORS, LEAVE_STATUS_LABELS } from '../utils/hrConstants';

interface Props {
  statusId: number;
  /**
   * Optional name override — pass when you have it from the joined
   * `LeaveModelView.statusName`. Renders verbatim instead of the constants
   * lookup so the DB stays the source of truth.
   */
  statusName?: string | null;
  /**
   * Optional colour from `LeaveModelView.statusColor`. Accepts a Mantine theme
   * colour name (e.g. `green`) or a hex/rgba string — hex is rendered as a
   * tinted background + matching text colour.
   */
  statusColor?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const isHex = (s: string) => /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(s.trim());

export function LeaveStatusBadge({ statusId, statusName, statusColor, size = 'sm' }: Props) {
  const label = statusName?.trim() || LEAVE_STATUS_LABELS[statusId] || `Status ${statusId}`;
  const colorHint = statusColor?.trim() || LEAVE_STATUS_COLORS[statusId];

  // Hex / rgba: render as inline-styled badge so we use the actual DB colour.
  if (colorHint && isHex(colorHint)) {
    return (
      <Badge variant="light" size={size} style={{ backgroundColor: colorHint + '22', color: colorHint }}>
        {label}
      </Badge>
    );
  }

  return (
    <Badge color={colorHint ?? 'gray'} variant="light" size={size}>
      {label}
    </Badge>
  );
}
